<!-- src/views/AddEducationalMaterial.vue -->
<template>
  <div class="">
    <create-educational-material
      :editId="editId"
      :type="type"
      :selectedUserId="selectedUserId"
      :currentFolder="currentFolder"
      :tumorSites="tumorSites"
      @saved="forwardSaved"
    />
  </div>
</template>

<script>
import CreateEducationalMaterialComponent from "../components/create-educational-material.vue";
// import BreadcrumbsComponent from "../../../components/common/breadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EducationalMaterialAdd",
  data() {
    return {
      editing: false,
    };
  },
  props: {
    editId: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: "Collection",
    },
    saved: {
      type: Function,
      default: () => {},
    },
    currentFolder: {
      type: Object,
      default: null,
    },
    userGeographicRegion: {
      type: Object,
      default: null,
    },
    selectedUserId: {
      type: String,
      default: null,
    },
    tumorSites: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    "create-educational-material": CreateEducationalMaterialComponent,
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["renderSidebarAction", "sidebarAction"]),
    init() {
      if (this.$canAccess("myslidebox", "canAccessModule")) {
        this.renderSidebarAction("educational-material-sidebar");
        this.sidebarAction({ show: true, full: true });
      } else {
        this.$changeRoute(this.$redirectTo());
      }
    },
    forwardSaved(payload) {
      // re-emit event to parent
      this.$emit("saved", payload);
    },
  },
  computed: {
    ...mapGetters({
      sidebar: "getSidebar",
      crumbs: "getCrumbs",
    }),
  },
};
</script>
